module.exports = "/assets/data/4f0d8d05e3b3ad32d7592668e4ee6ed0-IP1.data.json";